import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

export const truncateNumber = (num: number, decimals = 2): number => {
	const factor = 10 ** decimals;
	return Math.trunc(num * factor) / factor;
};

export const roundNumber = (val: number, decimalPlaces = 2): number =>
	Number(val.toFixed(decimalPlaces));

export const capitalizeFirstLetter = (str: string | null | undefined) => {
	if (!str) return "";

	return str.charAt(0).toUpperCase() + str.slice(1);
};

const NBSP = "\u00A0";

export const formatThousands = (raw: string): string => {
	const digits = raw.replace(/\D/g, "");
	if (!digits) return "";
	return digits.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
};

export const parseThousands = (raw: string): number | undefined => {
	const digits = raw.replace(/\D/g, "");
	if (!digits) return undefined;
	const numeric = Number(digits);
	return Number.isNaN(numeric) ? undefined : numeric;
};

export const formatNumberOfDocuments = (
	count: number,
	t: (key: string) => string,
) => {
	if (count === 0) return t(Resources.Common.NoDocuments);
	if (count === 1) return `${count} ${t(Resources.Common.OneDocument)}`;
	if (count > 1 && count < 5)
		return `${count} ${t(Resources.Common.FewDocuments)}`;

	return `${count} ${t(Resources.Common.MoreDocuments)}`;
};
